/**
 * Determines if the app should be making /logEvent API calls
 */
class SplunkLoggingSingleton {
  _isCypressMode = false;
  _isEnabled = true;

  get isCypressMode() {
    return this._isCypressMode;
  }

  set isCypressMode(value) {
    this._isCypressMode = value;
  }

  get isEnabled() {
    return this._isEnabled;
  }

  set isEnabled(value) {
    this._isEnabled = value;
  }
}

module.exports = new SplunkLoggingSingleton();
